/**
 * src/api/governanceRolesApi.js
 *
 * Governance RBAC — role definitions and per-user assignments.
 * Calls the governance-roles-crud Azure Function.
 */

import { azureGet, azurePost } from './azureClient.js';

export async function readGovernanceRoleDefs(_tenantId) {
  const data = await azureGet('/api/governance-roles-crud', { op: 'defs' });
  return data.defs ?? [];
}

export async function readGovernanceRoleAssignments(_tenantId) {
  const data = await azureGet('/api/governance-roles-crud', { op: 'assignments' });
  return data.assignments ?? [];
}

export async function readMyGovernanceRoles(_tenantId) {
  try {
    const data = await azureGet('/api/governance-roles-crud', { op: 'mine' });
    return data.roles ?? [];
  } catch {
    // A failed read is not "holds no role" (GH #6920): null tells the risk
    // lifecycle screen it cannot tell, so it offers the step and the server
    // decides — never "you lack the role" on a read that did not happen.
    return null;
  }
}

export async function assignGovernanceRole(_tenantId, { userId, roleKey }) {
  await azurePost('/api/governance-roles-crud?op=assign', { userId, roleKey });
}

export async function revokeGovernanceRole(_tenantId, payload) {
  // payload is { assignmentId } or { userId, roleKey }.
  await azurePost('/api/governance-roles-crud?op=revoke', payload);
}
